import React from 'react'
import styled from 'styled-components'
import { CURRENCIES} from '../utils/Enum'
import { hexToRgba } from './HexToRGBA'
import { useWebsiteTheme } from './WebsiteTheme/WebsiteThemeContext'

export const MEDIA_SCREEN = { //Screen sizes for devices
  MOBILE: '480',
  TABLETS: '768',
  LAPTOPS: '1024',
  DESKTOPS: '1025',
  TV: '1500'
}


export const SelectButton = styled.select`
  display: flex;
  margin-left: 2%;
  margin-right: 1%;
  font-size: 1rem;
  min-width: 90px;
  color: ${props => props.theme.secondaryBg};
  cursor: pointer;
  border: solid 0.5px ${props => hexToRgba(props.theme.mainColor, 0.6)};
  border-radius: 5px;
  outline: none;
  background-color: ${props => hexToRgba(props.theme.mainBg,0.3)};
  padding: 0.5rem 1rem;

  @media screen and (max-width: ${MEDIA_SCREEN.TABLETS}px) {
    font-size: 0.8rem;
    padding: 0.4rem 0.8rem;
  }
`;


const CurrencySelector = ({setCurrency, currency}) => {
const {themeColors} = useWebsiteTheme()
  const handleSelect = (e) => {
    setCurrency(e.target.value);
  };

  return (
    <SelectButton value={currency} onChange={handleSelect}>
      {Object.keys(CURRENCIES).map(c => (
        <option style={{backgroundColor: themeColors.mainBg, color: themeColors?.secondaryBg}} key={c} value={c}>
          {c}
        </option>
      ))}
    </SelectButton>
  );
}

export default CurrencySelector